<div class="container" *ngIf="egreso">
    <mat-dialog-content class="mat-typography">
        <div class="px-2 text-center">
            <div class="alert alert-warning text-center" *ngIf="status == 'loading'">
                <div class="spinner-border text-primary text-center" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="alert alert-success" *ngIf="status == 'succes'">El egreso se ha agregado correctamente.</div>
            <div class="alert alert-danger" *ngIf="status == 'failed'">El egreso no se ha podido agregar.</div>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label class="w-100">Fecha</mat-label>
                        <input matInput [matDatepicker]="picker" class="w-100" formControlName="fecha">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-xs-12">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Proveedor</mat-label>
                        <input matInput type="text" formControlName="proveedor">
                    </mat-form-field>
                </div>
            </div>

            <mat-form-field class="example-full-width w-100">
                <mat-label class="w-100">Pedido</mat-label>
                <input matInput type="text" formControlName="pedido">
            </mat-form-field>

            <mat-form-field class="example-full-width w-100">
                <mat-label class="w-100">Descripción</mat-label>
                <textarea matInput type="text" formControlName="descripcion"></textarea>
            </mat-form-field>

            <mat-form-field class="example-full-width w-100">
                <mat-label class="w-100">Monto</mat-label>
                <input matInput type="number" formControlName="monto">
            </mat-form-field>

            <input type="submit" value="Agregar egreso" class="btn btn-danger mt-4 col-md-12 col-sm-12" name="" id=""
                [disabled]="form.invalid" />

        </form>
    </mat-dialog-content>
</div>